import { LocationNumbersService } from '../../../services'

const updateOnboardingConfig = async function ({ commit, dispatch, state }, config) {
  const {
    companyId,
    allowPhoneSystemIfRebillingDisabled,
    isNumberIntelligenceEnabled,
    isCallRecordingEnabled,
    isCallTranscriptionEnabled,
    messagingLimit,
    messagingLimitValue,
    messagingLimitUnit,
    messagingLimitType,
  } = config

  try {
    const data = await LocationNumbersService.updateOnboardingConfig(companyId, {
      allowPhoneSystemIfRebillingDisabled,
      isNumberIntelligenceEnabled,
      isCallRecordingEnabled,
      isCallTranscriptionEnabled,
      messagingLimit,
      messagingLimitValue,
      messagingLimitUnit,
      messagingLimitType,
    })
    return data
  } catch (error) {
    throw error
  }
}

export default updateOnboardingConfig
